export function removeFileNameFromURL(
  url: string,
  filename: string,
  baseUrl = window.location.href,
): string {
  const urlStartsWithBaseUrl = url.startsWith(baseUrl);
  const normalizedUrl = urlStartsWithBaseUrl ? url.replace(baseUrl, '') : url;
  const normalizedFilename = filename.replace('/', '');
  const regex = new RegExp(`/${normalizedFilename}(/|$)`);
  const normalizedUrlWithoutFilename = normalizedUrl.replace(regex, '');

  return urlStartsWithBaseUrl
    ? `${baseUrl}${normalizedUrlWithoutFilename}`
    : normalizedUrlWithoutFilename;
}
